import { Component, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { ProfileType } from 'src/app/constants/profile-type';
import { ApplicationService } from 'src/app/services/application.service';
import { ProfileService } from 'src/app/services/profile/profile.service';
import { TokenStorageService } from '../../services/token-storage/token-storage.service';
import { DownloadService } from '../../services/download/download.service';

export interface Menu {
  id: number;
  label: string;
  check: boolean;
  icon?: string;
  path: string;
}

@Component({
  selector: 'app-main-profile',
  templateUrl: './main-profile.component.html',
  styleUrls: ['./main-profile.component.css']
})
export class MainProfileComponent implements OnInit {

  id: string = '';
  name: string = '';
  nip: string = '';
  imgSrc: string = '';
  imageRealpath: string | undefined = '';

  onDestroy$ = new Subject<void>();
  selected = new FormControl(0);

  menus: Menu[] = [
    {
      id: ProfileType.GOLONGAN,
      label: 'Golongan',
      check: false,
      path: ProfileType.GOLONGAN_TEXT,
    },
    {
      id: ProfileType.PENDIDIKAN,
      label: 'Pendidikan',
      check: false,
      path: ProfileType.PENDIDIKAN_TEXT,
    },
    {
      id: ProfileType.JABATAN,
      label: 'Jabatan',
      check: false,
      path: ProfileType.JABATAN_TEXT,
    },
    {
      id: ProfileType.PENINJAUAN_MASA_KERJA,
      label: 'Masa Kerja',
      check: false,
      path: ProfileType.PENINJAUAN_MASA_KERJA_TEXT,
    },
    {
      id: ProfileType.PNS,
      label: 'CPNS/PNS',
      check: false,
      path: ProfileType.PNS_TEXT,
    },
    {
      id: ProfileType.DIKLAT,
      label: 'Diklat',
      check: false,
      path: ProfileType.DIKLAT_TEXT,
    },
    {
      id: ProfileType.KELUARGA,
      label: 'Keluarga',
      check: false,
      path: ProfileType.KELUARGA_TEXT,
    },
    {
      id: ProfileType.SKP,
      label: 'SKP',
      check: false,
      path: ProfileType.SKP_TEXT,
    },
    {
      id: ProfileType.PENGHARGAAN,
      label: 'Penghargaan',
      check: false,
      path: ProfileType.PENGHARGAAN_TEXT,
    },
    {
      id: ProfileType.ORGANISASI,
      label: 'Organisasi',
      check: false,
      path: ProfileType.ORGANISASI_TEXT,
    },
    {
      id: ProfileType.CLTN,
      label: 'CLTN',
      check: false,
      path: ProfileType.CLTN_TEXT,
    },
    {
      id: ProfileType.ANGKA_KREDIT,
      label: 'Angka Kredit',
      check: false,
      path: ProfileType.ANGKA_KREDIT_TEXT,
    },
    {
      id: ProfileType.PROFESI,
      label: 'Profesi',
      check: false,
      path: ProfileType.PROFESI_TEXT,
    },
    {
      id: ProfileType.PINDAH_INSTANSI,
      label: 'Instansi',
      check: false,
      path: ProfileType.PINDAH_INSTANSI_TEXT,
    },
    {
      id: ProfileType.KGB,
      label: 'KGB',
      check: false,
      path: ProfileType.KGB_TEXT,
    },
    {
      id: ProfileType.BUP,
      label: 'BUP',
      check: false,
      path: ProfileType.BUP_TEXT,
    },
    {
      id: ProfileType.KARIS_KARSU,
      label: 'Karis/Karsu',
      check: false,
      path: ProfileType.KARIS_KARSU_TEXT,
    },
  ];

  constructor(
    public applicationService: ApplicationService,
    private profileService: ProfileService,
    private tokenStorageService: TokenStorageService,
    private downloadService: DownloadService,
    private route: ActivatedRoute,) { }

  ngOnInit(): void {
    this.profileService.currentProfile$.pipe(takeUntil(this.onDestroy$)).subscribe((res) => {
      this.name = res.fullname!;
      this.nip = res.username!;
      this.imgSrc = '/assets/images/users/' + (res.gender?.id === 1 ? 'male-pp.jpg' : 'female-pp.jpg');
      this.imageRealpath = res.photo;
      if (this.imageRealpath) {
        this.imgSrc = this.downloadService.downloadUrl(5, this.imageRealpath!);
      }
    });
    this.route.paramMap.pipe(takeUntil(this.onDestroy$)).subscribe((params) => {
      this.id = params.get('profileId') || this.tokenStorageService.getId();
      this.applicationService.currentProfileId$.next(this.id);
      this.profileService.loadUser(this.id);
    });
  }

}
